import React, { useEffect, useState } from "react";
import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Form, Image, Input, InputNumber, Switch } from "antd";
import ButtonWrapper from "../../../views/components/reuseComp/ButtonWrapper";
import TextArea from "antd/es/input/TextArea";
import UploadFoodImage from "../../../lib/UploadFoodImage";
import { Button } from "antd";

const HeaderSection: React.FC<{
  isEditing: boolean;
  setIsEditing: (value: boolean) => void;
  handleCancel: () => void;
  handleSave: () => void;
  form: any;
  headerData?: {
    logo?: string;
    links?: {
      facebook: string;
      instagram: string;
      twitter: string;
      youtube: string;
    };
    email: string;
    phone: string;
  };
  loading?: boolean;
}> = ({
  isEditing,
  setIsEditing,
  handleCancel,
  handleSave,
  form,
  loading,
  headerData,
}) => {
  useEffect(() => {
    if (headerData) {
      form.setFieldsValue({
        header: {
          logo: headerData.logo ? [headerData.logo] : [],
          links: {
            facebook: headerData.links?.facebook || "",
            instagram: headerData.links?.instagram || "",
            twitter: headerData.links?.twitter || "",
            youtube: headerData.links?.youtube || "",
          }, 
          email: headerData.email || "",
          phone: headerData.phone || "",
        },
      });
    } else {
      form.resetFields();
    }
  }, [headerData, form]);

  return (
    <div>
      {!isEditing ? (
        <>
          <div className="rounded-[20px] overflow-hidden">
            <table className="overflow-x-auto hidden min-w-full sm:table">
              <thead>
                <tr className="bg-primary text-white">
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    logo
                  </th>
                  <th className="py-3 text-xs md:text-base px-4 text-left">
                    Links
                  </th>
                  <th className="py-3 text-xs md:text-base px-4 text-right">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {headerData ? (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td className="py-3 px-4 ">
                      <Image src={headerData.logo} width={100} height={100} />
                    </td>
                    <td className="py-3 px-4 ">
                      <ul className="space-y-1">
                        <li className="list-disc">
                          <b>Facebook: </b>
                          <a href={headerData?.links?.facebook} target="_blank">
                            {headerData?.links?.facebook}
                          </a>
                        </li>
                        <li className="list-disc">
                          <b>Instagram: </b>
                          <a
                            href={headerData?.links?.instagram}
                            target="_blank"
                          >
                            {headerData?.links?.instagram}
                          </a>
                        </li>
                        <li className="list-disc">
                          <b>Twitter: </b>
                          <a href={headerData?.links?.twitter} target="_blank">
                            {headerData?.links?.twitter}
                          </a>
                        </li>
                        <li className="list-disc">
                          <b>Youtube: </b>
                          <a href={headerData?.links?.youtube} target="_blank">
                            {headerData?.links?.youtube}
                          </a>
                        </li>
                      </ul>
                    </td>

                    <td className="py-3 px-4  text-primary">
                      <div className="flex items-center gap-4 justify-end">
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer hover:text-blue-600 text-[20px]"
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8]">
                    <td colSpan={4} className="text-center py-6 text-gray-500 ">
                      <Button type="dashed" onClick={() => setIsEditing(true)}>
                        Add data
                      </Button>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>

          {/* Mobile View */}
          <table className="min-w-full border-collapse table sm:hidden">
            <tbody>
              {headerData ? (
                <tr className="bg-[#F9F9F9] border-b-2 border-[#e9e8e8] sm:table-row block mb-4 sm:mb-0 rounded-lg sm:rounded-none shadow-sm sm:shadow-none">
                  {/* Banner */}
                  <td className="py-2 px-4  block sm:table-cell">
                    <span className="font-semibold text-primary sm:hidden block mb-1 text-sm">
                      logo:
                    </span>
                    <Image src={headerData.logo} width={100} />
                  </td>

                  <td className="py-2 px-4  block sm:table-cell">
                    <ul className="space-y-1">
                      <li className="list-disc">
                        <b>Facebook: </b>
                        <a href={headerData?.links?.facebook} target="_blank">
                          {headerData?.links?.facebook}
                        </a>
                      </li>
                      <li className="list-disc">
                        <b>Instagram: </b>
                        <a href={headerData?.links?.instagram} target="_blank">
                          {headerData?.links?.instagram}
                        </a>
                      </li>
                      <li className="list-disc">
                        <b>Twitter: </b>
                        <a href={headerData?.links?.twitter} target="_blank">
                          {headerData?.links?.twitter}
                        </a>
                      </li>
                      <li className="list-disc">
                        <b>Youtube: </b>
                        <a href={headerData?.links?.youtube} target="_blank">
                          {headerData?.links?.youtube}
                        </a>
                      </li>
                    </ul>
                  </td>

                  {/* Action */}
                  <td className="py-2 px-4 block sm:table-cell">
                    <span className="font-semibold text-primary sm:hidden block mb-2 text-sm">
                      Action:
                    </span>
                    <div className="flex items-center gap-4">
                      {headerData ? (
                        <EditOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer hover:text-blue-600 text-[18px]"
                        />
                      ) : (
                        <PlusOutlined
                          onClick={() => setIsEditing(true)}
                          className="cursor-pointer hover:text-green-600 text-[18px]"
                        />
                      )}
                    </div>
                  </td>
                </tr>
              ) : (
                <tr className="bg-[#F9F9F9] border-2  border-[#e9e8e8]">
                  <td colSpan={4} className="text-center py-6 text-gray-500 ">
                    <Button type="dashed" onClick={() => setIsEditing(true)}>
                      Add data
                    </Button>
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </>
      ) : (
        <div>
          <div className="bg-[#F9F9F9] p-3 sm:p-6 rounded-lg sm:rounded-2xl shadow-sm">
            <Form layout="vertical" form={form}>
              <Form.Item
                label="Upload logo"
                name={["header", "logo"]}
                rules={[{ required: true, message: "Please upload a logo" }]}
              >
                <UploadFoodImage maxUploadCount={1} bannerAspect={5 / 2} />
              </Form.Item>
              <div className="grid grid-cols-2">
                <Form.Item
                  label="Email"
                  name={["header", "email"]}
                >
                  <Input placeholder="enter email" className=" w-full" />
                </Form.Item>
                <Form.Item
                  label="Phone Number"
                  name={["header", "phone"]}
                >
                  <Input placeholder="enter phone number" className=" w-full" />
                </Form.Item>
              </div>
              <div className="grid grid-cols-2">
                <Form.Item
                  label="Instagram"
                  name={["header", "links", "instagram"]}
                >
                  <Input placeholder="instagram" className=" w-full" />
                </Form.Item>
                <Form.Item
                  label="Twitter"
                  name={["header", "links", "twitter"]}
                >
                  <Input placeholder="twiiter" className=" w-full" />
                </Form.Item>
                <Form.Item
                  label="Facebook"
                  name={["header", "links", "facebook"]}
                >
                  <Input placeholder="facebook" className=" w-full" />
                </Form.Item>
                <Form.Item
                  label="Youtube"
                  name={["header", "links", "youtube"]}
                >
                  <Input placeholder="youtube" className=" w-full" />
                </Form.Item>
              </div>
            </Form>
          </div>

          <div className="flex justify-start gap-3 mt-7 sticky bottom-5">
            <ButtonWrapper
              type="primary"
              onClick={handleSave}
              loading={loading}
            >
              Save
            </ButtonWrapper>
            <ButtonWrapper onClick={handleCancel}>Cancel</ButtonWrapper>
          </div>
        </div>
      )}
    </div>
  );
};

export default HeaderSection;
